import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/logo-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-427e8d7e")

_pushScopeId("data-v-427e8d7e")
const _hoisted_1 = { class: "navbar navbar-expand-lg container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "logo"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "navbar-toggler text-primary",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z"
  })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("ul", { class: "navbar-nav mr-auto" }, [
  /*#__PURE__*/_createVNode("li", { class: "nav-item" })
], -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Sign Up ")
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4M15,5.9C16.16,5.9 17.1,6.84 17.1,8C17.1,9.16 16.16,10.1 15,10.1A2.1,2.1 0 0,1 12.9,8A2.1,2.1 0 0,1 15,5.9M4,7V10H1V12H4V15H6V12H9V10H6V7H4M15,13C12.33,13 7,14.33 7,17V20H23V17C23,14.33 17.67,13 15,13M15,14.9C17.97,14.9 21.1,16.36 21.1,17V18.1H8.9V17C8.9,16.36 12,14.9 15,14.9Z"
  })
], -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Login ")
const _hoisted_12 = /*#__PURE__*/_createVNode("svg", {
  style: {"width":"24px","height":"24px"},
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M19,21V19H15V17H19V15L22,18L19,21M13,18C13,18.71 13.15,19.39 13.42,20H2V17C2,14.79 5.58,13 10,13C11,13 11.96,13.09 12.85,13.26C13.68,13.42 14.44,13.64 15.11,13.92C13.83,14.83 13,16.32 13,18M4,17V18H11C11,16.96 11.23,15.97 11.64,15.08L10,15C6.69,15 4,15.9 4,17M10,4A4,4 0 0,1 14,8A4,4 0 0,1 10,12A4,4 0 0,1 6,8A4,4 0 0,1 10,4M10,6A2,2 0 0,0 8,8A2,2 0 0,0 10,10A2,2 0 0,0 12,8A2,2 0 0,0 10,6Z"
  })
], -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = /*#__PURE__*/_createVNode("button", { class: "btn btn-lg squared text-white" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-male fa-3x" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "fw-bold" }, "Personal", -1)
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = { class: "text-center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("button", { class: "btn btn-lg squared text-white" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-building fa-3x" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Business ")
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "divider container" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("nav", _hoisted_1, [
      _createVNode("div", null, [
        _createVNode(_component_router_link, { to: { name: 'auth.login' } }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      (!_ctx.$isAdmin)
        ? (_openBlock(), _createBlock("button", _hoisted_3, [
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        (_ctx.$route.name == 'auth.login' && !_ctx.$isAdmin)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModal = true)),
                type: "button",
                class: "btn btn-sm text-white form-control"
              }, [
                _hoisted_8,
                _hoisted_9
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.$route.name != 'auth.login')
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm text-white form-control",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'auth.login' })))
              }, [
                _hoisted_11,
                _hoisted_12
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Dialog, {
        style: {"min-width":"300px"},
        header: "Sign Up",
        visible: _ctx.showModal,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModal = $event))
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("p", _hoisted_15, [
                _createVNode(_component_router_link, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModal = false)),
                  to: { name: 'auth.register' }
                }, {
                  default: _withId(() => [
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("p", _hoisted_20, [
                _createVNode(_component_router_link, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = false)),
                  to: { name: 'auth.register.business' }
                }, {
                  default: _withId(() => [
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _hoisted_24
  ], 64))
})